import * as React from "react";
import { useTheme } from "../contexts/ThemeContext";
import * as styles from "../styles/themeToggle.module.scss";
import DarkSvg from "../assets/icons/moon.svg";
import LightSvg from "../assets/icons/sun.svg";

const Dark = ({ size = 24, ...props }) => (
  <DarkSvg width={size} height={size} {...props} />
);

const Light = ({ size = 24, ...props }) => (
  <LightSvg width={size} height={size} {...props} />
);

export default function ThemeToggle({ variant }) {
  const { mode, theme, setMode } = useTheme();

  const toggleMode = () => {
    if (mode === "light") {
      setMode("dark");
    } else if (mode === "dark") {
      setMode("system");
    } else {
      setMode("light");
    }
  };

  const Icon = theme === "dark" ? Dark : Light;
  const ReverseIcon = theme === "dark" ? Light : Dark;

  if (variant === "button") {
    return (
      <button
        className={`${styles.toggleButton} ${theme === "light" ? "active" : ""}`}
        onClick={toggleMode}
        aria-label={`Theme: ${mode}. Click to cycle through themes.`}
        title={`Current: ${mode} (effective: ${theme})`}
      >
        <Icon
          className={styles.toggleIcon}
          aria-hidden="true"
          focusable="false"
        />
      </button>
    );
  }

  return (
    <span
      className={styles.toggleText}
      onClick={toggleMode}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggleMode();
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={`Theme: ${mode}. Click to cycle through themes.`}
      title={`Current: ${mode} (effective: ${theme})`}
    >
      View site in{" "}
      <ReverseIcon
        className={styles.toggleIconText}
        aria-hidden="true"
        focusable="false"
      />{" "}
      {mode === "light" ? "Dark" : "Light"} Mode
    </span>
  );
}
